import native from '@zz-common/native-adapter';
import { Toast } from '@zz-common/zz-ui';
import { url } from '@zz-common/zz-utils'

/**
 * 获取指定 Cookie 值
 * @param {String} k 指定的 Cookie 名
 */
export function getCookie(k) {
  const res = RegExp('(^|; )' + encodeURIComponent(k) + '=([^;]*)').exec(document.cookie)
  return res && res[2]
}

export const deviceType = (function() {
  const ua = window.navigator.userAgent
  return {
    Mobile: !!ua.match(/AppleWebKit.*Mobile.*/i), // 移动端
    iOS: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i), // ios
    iPhone: !!ua.match(/iPhone/i), // iphone
    iPad: !!ua.match(/iPad/i), // ipad
    Android: !!ua.match(/Android/i) // android
    // 判断鸿蒙可用zz-utils的 env.$isOpenHarmony
  }
})()

/**
 * 返回
 * @returns
 */
export function goBack() {
  if (native.in('zz')) {
    native.close()
  } else {
    native.goBack()
  }
}

/**
 * 登录
 */
export function login() {
  return new Promise<void>((resolve, reject) => {
    // TODO--登录拦截是否需要更改
    if (getCookie('PPU') && parseInt(getCookie('uid') || '') > 0) {
      resolve()
    } else {
      native.wrap('login')((res) => {
        if (Number(res.code) === 0) {
          //  在 iOS 下刚登陆后存在没有 cookie 的情况
          if (deviceType.iOS) {
            native.wrap('getCookie')(() => {})

            const startTime = new Date().getTime()
            const timer = setInterval(() => {
              const uid = getCookie('uid')
              const diffTime = new Date().getTime() - startTime
              if (diffTime > 1000 || uid) {
                console.log('got uid: ', uid)
                clearInterval(timer)
                resolve()
              }
            }, 100)
          } else {
            resolve()
          }
        } else {
          //  res.code == -100    登录失败
          //  res.code == -1      登录失败，比如用户取消，不做任何处理
          reject(res)
        }
      })
    }
  })
}
// 是否为IphoneX
export const isIphoneX = () => {
  const ua = navigator.userAgent
  const isIOS = ua.toLocaleUpperCase().indexOf('IPHONE') >= 0;
  if (isIOS && window.screen.height >= 812) {
    return true;
  }
  return false;
};

export function debounce(fn: Function, delay: any) {
  let timer: any = null
  return function(...args) {
    if (timer) clearTimeout(timer)
    // 使用箭头函数来处理this问题
    timer = setTimeout(() => fn.apply(this, args), delay)
  }
}

// 统一的跳转逻辑
export function jumpTo(targetUrl) {
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!targetUrl && targetUrl !== 'null' && targetUrl !== 'undefined') {
    safeJumpTo({
      targetUrl
    })
  } else { // 异常链接时提供提示
    Toast('提示：暂不支持跳转')
  }
}

// 从url上面获取 预渲染参数 ：isPreRender=1
export function isPreRender() {
  const isProcess = url.getParam('isPreRender') || 0
  return +isProcess || 0
}

// 替换富文本中的ul和ol
export function revertStyle(text) {
  let res = text
  try {
    res = res?.replace(/<ul(.*?)>(.*?)<\/ul>/g, (match, $1, $2) => {
      const content = $2?.replace(/<li(.*?)>(.*?)<\/li>/g, (match, $1, $2) => {
        const inlineStyle = $2.match(/<span\s+style="(.*)">/)
        const inlineColor = inlineStyle && inlineStyle?.[1]?.match(/color: (.*);\s*/)?.[0]
        return `<div style="${inlineColor || ''}"><span style="margin-right: 0.5em;">•</span><span>${$2}</span></div>`
      })
      return `<div>${content}</div>`
    })
  } catch (error) {
    console.log('error to exchange ul tag', error)
  }
  try {
    res = res?.replace(/<ol(.*?)>(.*?)<\/ol>/g, (match, $1, $2) => {
      let idx = 0
      const content = $2?.replace(/<li(.*?)>(.*?)<\/li>/g, (match, $1, $2) => {
        idx = idx + 1
        const inlineStyle = $2.match(/<span\s+style="(.*)">/)
        const inlineColor = inlineStyle && inlineStyle?.[1]?.match(/color: (.*);\s*/)?.[0]
        return `<div style="${inlineColor || ''}"><span style="margin-right: 0.5em;">${idx}.</span><span>${$2}</span></div>`
      })
      return `<div>${content}</div>`
    })
  } catch (error) {
    console.log('error to exchange ol tag', error)
  }

  try {
    res = res?.replace(/<em(.*?)>(.*?)<\/em>/g, (match, $1, $2) => {
      return `<em ${$1}style="font-style: italic">${$2}</em>`;
    });
  } catch (error) {
    console.log('error to exchange em', error)
  }
  return res
}

export function safeJumpTo (config) {
  const targetUrl = config?.targetUrl
  let skipErrorText: string | null = null
  // 链接为原生转转链接且当前环境不为转转--尝试唤起转转，否则提示
  if (targetUrl.indexOf('zhuanzhuan://') > -1 && !native.in('zz')) {
    skipErrorText = '请前往转转app打开'
  }
  // 链接为原生找靓机链接且当前环境不为找靓机--尝试唤起找靓机，否则提示
  if (targetUrl.indexOf('zljgo://') > -1 && !native.in('zlj')) {
    skipErrorText = '请前往找靓机app打开'
  }
  if (skipErrorText) {
    Toast(skipErrorText)
  } else {
    if (config?.targetUrl?.indexOf?.('zhuanzhuan.com') !== -1) { // 端内链接用native跳
      native.skipToUrl(config)
    } else if (config?.targetUrl) { // 端外链接
      window.location.href = config?.targetUrl
    }
  }
}
